module.exports = __webpack_public_path__ + "static/media/plaquette_commerciale.ecc6de9e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/gpi/documents/common/plaquette_commerciale.pdf
// module id = 850
// module chunks = 40